import { createContext, useContext } from 'react';

const PermissionsContext = createContext([]);

export const usePermissions = () => useContext(PermissionsContext);

export const useHasPermission = (key) => {
  const perms = useContext(PermissionsContext);
  return perms.includes(key) || perms.includes('*');  // '*' = PLATFORM_OWNER wildcard
};

export default PermissionsContext;
